import {
  AppEnv,
  IAppConfig,
  PiTargetBg,
} from '../../config/appConfig/appConfig.types';

// Default data for init of context
const appConfigDefault: IAppConfig = {
  isProd: false,
  isTrueProd: false,
  isMock: false,
  isLocal: false,

  app: {
    shortName: '',
    displayName: '',
    env: AppEnv.Mock,
    version: '',
    versionName: '',
  },

  api: {
    useDirectHost: false,
    auth: '',
    graphql: '',
    restEndpoint: '',
    senetApp: '',
    sso: '',
    piHost: '',
  },

  analytics: {
    quantum: {
      enabled: false,
      devEndpoint: '',
      prodEndpoint: '',

      config: {
        domain: '',
        appName: '',
        appVersion: '',
        packageVersion: '',
        appEnvName: '',
        startSession: '',
        requirementsVersion: '',
      },
    },

    adobe: {
      enabled: false,
      devEndpoint: '',
      prodEndpoint: '',
    },
  },

  dataDog: {
    enabled: false,
    service: '',
    env: '',
    applicationId: '',
    clientToken: '',
    sessionSampleRate: 100,
  },

  auth: {
    targetBg: PiTargetBg.Default,
    loginUrl: '',
    piClientId: '',
    piEsso: {
      clientId: '',
      redirectUri: '',
    },
    autoLogout: {
      idleWarningMins: 5,
      postIdleWarnMins: 5,
    },
  },

  tdcs: {
    enabled: false,
    apiKey: '',
    host: '',
    config: {
      appVersion: '',
      clientType: '',
      deviceId: '',
      osVersion: '',
      deviceType: '',
    },
    localConfig: '', // for local development only
  },

  // Access Google API library
  google: {
    siteKey: '',
  },
};

export default appConfigDefault;
